import { Box } from "@mui/material";
import PageBanner from "../components/application/PageBanner";
import { Images } from "../models/assets-files";

import { useEffect, useState } from "react";
import InputSubmit from "../components/common/InputSubmit";
import useScreen from "../components/common/UseScreen";
import ScammersLibraryTable from "../components/scammers-library/ScammersLibraryTable";
import {
  BannerTexts,
  GeneralButtonLabel,
  ScammersLibraryText,
  SnackbarMsg,
} from "../data/texts";
import { ImageService } from "../services/image.service";
import { ScammersLibraryService } from "../services/scammers-library.service";
import { Scammer } from "../models/scammers-library.model";
import { PaginationModel } from "../components/common/CustomTable";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../store/system.store";
import { EventLoppService } from "../services/event-loop.service";

const ScammersLibrary = () => {
  const { isMobile } = useScreen();
  const [searchValue, setSearchValue] = useState<string>("");
  const [scammers, setScammers] = useState<Scammer[]>([]);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const dispatch = useDispatch();

  const [totalScammersNumber, setTotalScammersNumber] = useState<number>(0);

  const pageLimit = 7;

  useEffect(() => {
    fetchScammers();
  }, [page]);

  useEffect(() => {
    EventLoppService.nextTick(() => {
      setIsLoading(!scammers.length);
    });
  }, [scammers]);

  const fetchScammers = async () => {
    setIsLoading(true);
    const data = await ScammersLibraryService.getFilteredScammersLibrary(
      searchValue,
      page,
      pageLimit
    );

    if (!data) {
      dispatch(
        showSnackbar({
          isError: true,
          msg: SnackbarMsg.SOMETHING_WRONG,
        })
      );
      return;
    }
    if (!data.list.length) {
      setTotalScammersNumber(0);
      setIsLoading(false);
      return;
    }

    setTotalScammersNumber(data.totalCount);
    setScammers(data.list);
  };

  const handleSubmit = () => {
    if (isLoading) return;
    if (page === 0) {
      fetchScammers();
    } else {
      setPage(0);
    }
  };

  const onPaginationModelChange = (model: PaginationModel) => {
    setPage(model.page);
  };
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <PageBanner
        containerSx={{ padding: isMobile ? "0" : "24px" }}
        imageSrc={ImageService.getLocalImgPath(
          Images.Folders.BANNERS,
          Images.Banners.LAPTOPS,
          "png"
        )}
        title={BannerTexts.SCAMMERS_LIBRARY}
        subtitle={BannerTexts.SCAMMERS_LIBRARY_DESCRIPTION}
      >
        <slot name="content">
          <InputSubmit
            handleSubmit={handleSubmit}
            onInput={setSearchValue}
            button={{ label: GeneralButtonLabel.SEARCH }}
            containerSx={{
              width: "100%",
              height: isMobile ? "unset" : "58px",
              maxWidth: "600px",
              flexDirection: isMobile ? "column" : "row",
            }}
            input={{
              placeholder: ScammersLibraryText.BANNER_INPUT_PLACEHOLDER,
            }}
          />
        </slot>
      </PageBanner>
      <Box sx={{ padding: "24px" }}>
        <ScammersLibraryTable
          page={page}
          isLoading={isLoading}
          onPaginationModelChange={onPaginationModelChange}
          totalScammersNumber={totalScammersNumber}
          scammers={scammers}
        />
      </Box>
    </Box>
  );
};

export default ScammersLibrary;
